import axios from 'axios';
import HllUI from 'hll-m-ui';
import store from '../store';
import mockConfig from '@/mocks';
import config from '@/commons/config';
import { getUrlParamsNew } from '@/commons/tools';
import { getToken, removeToken } from '@/commons/tools/auth';

// 请求超时时间
const AXIOS_DEFAULT_TIMEOUT = 15000;

// 判断是否使用mock数据
if (config.isMock) {
  mockConfig(axios);
}

// 创建axios实例
const instance = axios.create({
  withCredentials: true,
  timeout: AXIOS_DEFAULT_TIMEOUT,
  // headers: {
  //   "Content-Type": "application/x-www-form-urlencoded"
  // },
  // 允许在向服务器发送前，修改请求数据
  // transformRequest: [function (data) {
  //   return qs.stringify(data)
  // }]
});

// 添加请求拦截器
instance.interceptors.request.use(
  function(config) {
    const urlParams = getUrlParamsNew();

    // 公共参数获取
    if (config.data && config.data.noCommon) {
      delete config.data.noCommon;
      return config;
    }
    const token = urlParams.token || urlParams._token || store.getters.getToken || getToken();
    const defaultParams = { token };
    config.params = Object.assign(defaultParams, config.params);
    config.data = { ...config.data, token };
    return config;
  },

  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  function(response) {
    if (!response.data) {
      return response;
    }

    const statusCode = Number(response.data.ret);

    switch (statusCode) {
      case 0:
        // 请求成功
        return Promise.resolve(response);
      case 10001:
        // 登录过期
        removeToken();
        HllUI.$hll.toast('登录过期，请重新登录');
    }

    return response;
  },
  function(error) {
    console.log('reject: ', error);
    return Promise.reject(error);
  }
);

export default instance;
